"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSerializedObjectSize = void 0;
const getStringSize_1 = require("./getStringSize");
const getSerializedObjectSize = (obj, options) => (0, getStringSize_1.getStringSize)(JSON.stringify(obj), options);
exports.getSerializedObjectSize = getSerializedObjectSize;
//# sourceMappingURL=getSerializedObjectSize.js.map